import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	getTeamMsgBySprId: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/team/team/getTeamMsgBySprId", params, successCallback, failCallback, exceptionCallback);
	},
	getTMemberBySprId: (readStorage, successCallback, failCallback, exceptionCallback) => {
		//console.log("in getTMemberBySprId",readStorage)
		//队员
		let teammbrs = sessionStorage.getItem("teammembes")
		if (teammbrs && readStorage) {
			successCallback({ data: JSON.parse(sessionStorage.getItem("teammembes")) })
			return;
		}

		let sprintIdX = localStorage.getItem("sprintId")
		if (sprintIdX) {
			let params = { sprintId: sprintIdX }
			console.log("sprintIdX", sprintIdX)
			// 包装成功回调，在数据返回后缓存
			const wrappedSuccessCallback = (response) => {
				sessionStorage.setItem("teammembes", JSON.stringify(response.data)) //缓存数据，下次直接读
				successCallback(response);
			};
			ApiUtils.getLoadingAjax(constant.serverUrl + "/team/team/getTMemberBySprId", params, wrappedSuccessCallback, failCallback, exceptionCallback);
		} else {
			successCallback({})
		}
	}
}

export default api;
